import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('standalone_workflows_1'),
    descriptionTrial: defineMessage('approvalmax_allows_to_s_ements_sales_quotes_etc'),
    descriptionNormal: defineMessage('approvalmax_allows_to_s_ements_sales_quotes_etc'),
    learnMore: defineMessage('learn_more'),
    buttonCreateTip: defineMessage('standalone_workflow'),
    buttonCreateText: defineMessage('create'),
    noFound: defineMessage('no_approval_workflow_fo_lease_refine_the_search'),
    searchPlaceholder: defineMessage('type_workflow_name'),
};
